import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-style-two-page',
  templateUrl: './work-style-two-page.component.html',
  styleUrls: ['./work-style-two-page.component.scss']
})
export class WorkStyleTwoPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
